<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import InputProposal from '@/components/common/InputProposal'
import InputConstant from '@/components/common/InputConstant'
import axios from 'axios'

export default {
  name: 'BotTemplateCard',
  props: {
    hexId: String
  },

  data() {
    return {
      isCard: false,
      botTemplate: null,
      editName: false,
      editDescription: false,
      editHive: false,
      editHiveBotId: false,
      editEffortSaved: false,
      botTemplateUpdating: false,
      hiveBotDataUpdating: false,
      botIncubateLoader: false,
      showProposal: false,
      showConstants: false,
      binFile: null,
      libFiles: [],
      botUpating: false,
      botTemplateBinariesUpdation: false,
      acceptFormats: '.dll,.jar',
      botTemplateBinariesClassName: '',
      updateForm: null,
      botTemplateBinariesUpdating: false,
      name: '',
      description: '',
      hiveTypeSelected: '',
      hiveSelected: {},
      hiveBotId: '',
      effortSaved: '',
      className: '',
      hash: ''
    }
  },

  computed: {
    ...mapState({
      botTemplateHive: state => state.botTemplates.botTemplateHive,
      botTemplateHiveData: state => state.botTemplates.botTemplateHiveData,
      hiveTypes: state => state.enums.hiveTypes,
      hives: state => state.hives.hives,
      bots: state => state.botTemplates.bots
    }),
    ...mapGetters({
      can: 'can'
    }),
    filteredHivesForHiveType() {
      return this.hives.filter(hive => hive.hiveType === this.hiveTypeSelected)
    }
  },

  watch: {
    hexId() {
      this.init(this.hexId)
    },
    botTemplate() {
      this.name = this.botTemplate.name
      this.description = this.botTemplate.description
      this.hiveBotId = this.botTemplate.hiveBotId
      this.effortSaved = this.botTemplate.effortSaved
      this.libFiles = []
      this.binFile = null
      this.botTemplateBinariesClassName = ''
    },
    botTemplateHive() {
      this.hiveSelected = this.botTemplateHive[this.botTemplate.hexId]
      this.hiveTypeSelected = this.botTemplateHive[this.botTemplate.hexId]
        ? this.botTemplateHive[this.botTemplate.hexId].hiveType
        : ''
    },
    botTemplateHiveData() {
      this.className = this.botTemplateHiveData.className
      this.hash = this.botTemplateHiveData.hash
      this.botTemplateBinariesClassName = this.botTemplateHiveData.className
    }
  },

  created() {
    if (this.hexId || this.$router.currentRoute.name === 'bot-template-card') {
      if (this.$router.currentRoute.name === 'bot-template-card') {
        this.isCard = true
      } else {
        this.isCard = false
      }
      const id = this.$route.params.hexId || this.hexId
      this.init(id)
    }
  },

  methods: {
    init(id) {
      this.botTemplateUpdating = true
      axios
        .get(`/api/v1/botTemplates/${id}`)
        .then(response => {
          this.botTemplate = response.data
          this.getAssociations()
          this.getHiveTypes()
          if (this.hives && this.hives.length > 0) {
            this.getHives()
          }
          this.botTemplateUpdating = false
        })
        .catch(error => {
          console.log(error)
          this.botTemplateUpdating = false
        })
    },
    gotoList() {
      this.$router.replace({ name: 'bot-template-list' }).catch()
    },
    getAssociations() {
      this.getBotTemplateHive()
      this.getBotTemplateHiveBotData()
      this.getBot()
    },

    async getBot() {
      this.botUpating = true
      try {
        await this.$store.dispatch('fetchBot', this.botTemplate)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Bot',
          description: e.response.data.message,
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botUpating = false
    },

    async getBotTemplateHive() {
      this.botTemplateUpdating = true
      try {
        await this.$store.dispatch('fetchBotTemplateHive', this.botTemplate)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Agent for Bot Template(s)',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botTemplateUpdating = false
    },

    async getBotTemplateHiveBotData() {
      this.hiveBotDataUpdating = true
      try {
        await this.$store.dispatch('fetchBotTemplateHiveData', this.botTemplate)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Hive Bot Data',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.hiveBotDataUpdating = false
    },

    async getHiveTypes() {
      this.botTemplateUpdating = true
      try {
        await this.$store.dispatch('fetchHiveTypes')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Agent Type(s)',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botTemplateUpdating = false
    },

    async getHives() {
      this.botTemplateUpdating = true
      try {
        await this.$store.dispatch('fetchHives')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Agent',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botTemplateUpdating = false
    },

    async setConstants(value) {
      this.botTemplateUpdating = true
      try {
        await this.$store.dispatch('updateBotTemplate', {
          body: { constants: value },
          hexId: this.botTemplate.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Bot constants updated Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Bot constants update Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botTemplateUpdating = false
    },

    async setProposals(value) {
      this.botTemplateUpdating = true
      try {
        await this.$store.dispatch('updateBotTemplate', {
          body: { proposals: value },
          hexId: this.botTemplate.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Bot proposal updated Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Bot proposal update Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botTemplateUpdating = false
    },

    async setName() {
      this.botTemplateUpdating = true
      this.editName = false
      try {
        await this.$store.dispatch('updateBotTemplate', {
          body: { name: this.name },
          hexId: this.botTemplate.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Bot Template renamed Successfully',
          description: 'Bot Template renamed Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Bot Template rename Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetName()
      }
      this.botTemplateUpdating = false
    },

    resetName() {
      this.editName = false
      this.name = this.botTemplate.name
    },

    async setDescription() {
      this.botTemplateUpdating = true
      this.editDescription = false
      try {
        await this.$store.dispatch('updateBotTemplate', {
          body: { description: this.description },
          hexId: this.botTemplate.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Bot Template description changed Successfully',
          description: 'Bot Template description changed Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Bot Template description change Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetDescription()
      }
      this.botTemplateUpdating = false
    },

    resetDescription() {
      this.editDescription = false
      this.description = this.botTemplate.description
    },

    async setHiveBotId() {
      this.botTemplateUpdating = true
      this.editHiveBotId = false
      try {
        await this.$store.dispatch('updateBotTemplate', {
          body: { hiveBotId: this.hiveBotId },
          hexId: this.botTemplate.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Bot Identifier assignment changed Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Bot Identifier assignment change Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetHiveBotId()
      }
      this.botTemplateUpdating = false
    },

    resetHiveBotId() {
      this.editHiveBotId = false
      this.hiveBotId = this.botTemplate.hiveBotId
    },

    async setEffortSaved() {
      this.botTemplateUpdating = true
      this.editEffortSaved = false
      try {
        await this.$store.dispatch('updateBotTemplate', {
          body: { effortSaved: this.effortSaved },
          hexId: this.botTemplate.hexId
        })
        await this.$store.dispatch('directNotification', {
          message: 'Effort savings changed Successfully',
          type: 'success',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          message: 'Effort savings change Failed',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          type: 'error',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.resetEffortSaved()
      }
      this.botTemplateUpdating = false
    },

    resetEffortSaved() {
      this.editEffortSaved = false
      this.effortSaved = this.botTemplate.effortSaved
    },

    async setHive() {
      this.botTemplateUpdating = true
      this.editHive = false
      try {
        await this.$store.dispatch('setHiveToBotTemplate', {
          hiveId: this.hiveSelected.hexId,
          botTemplate: this.botTemplate
        })
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Agent updated for Bot Template Successfully',
          description: 'Agent updated for Bot Template Successfully',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to update Agent',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry'
        })
      }
      try {
        await this.$store.dispatch('fetchBotTemplateHive', this.botTemplate)
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Agent for Bot Template',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botTemplateUpdating = false
    },

    resetHive() {
      this.editHive = false
      this.hiveSelected = this.botTemplateHive[this.botTemplate.hexId]
    },

    async incubateBot(botTemplate) {
      this.botIncubateLoader = true
      try {
        await this.$store.dispatch('incubateBot', botTemplate.hexId)
        this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Bot incubated Successfully',
          description: 'The Bot incubation successful, Bot created!',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      } catch (e) {
        this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Bot incubation Failed',
          description: e.toString(),
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.botIncubateLoader = false
    },

    async uploadUpdateBinFile() {
      this.binFile = this.$refs.updateBinInput.files[0]
      if (this.updateForm === null) {
        this.updateForm = new FormData()
      }
      this.updateForm.append('file', this.binFile)
    },

    async uploadUpdateLibFile() {
      this.libFiles = this.$refs.updateLibsInput.files
      if (this.updateForm === null) {
        this.updateForm = new FormData()
      }
      this.updateForm.append('libs', this.libFiles)
    },

    async updateBotBinaries() {
      this.botTemplateBinariesUpdating = true
      let saveData = {
        file: this.binFile,
        libs: Array.from(this.libFiles),
        className: this.botTemplateBinariesClassName
      }
      try {
        let savedBotTemplate = await this.$store.dispatch(
          'updateBotTemplateBinaries',
          {
            body: saveData,
            hexId: this.botTemplate.hexId
          }
        )
        this.botTemplateBinariesUpdating = false
        await this.$store.dispatch('directNotification', {
          type: 'success',
          message: 'Bot Template binaries Updated',
          description: `Bot Template binaries ${savedBotTemplate.hexId} have been updated successfully`,
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
        this.botTemplateBinariesUpdation = false
      } catch (err) {
        this.botTemplateBinariesUpdating = false
        this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Bot template updation Failed',
          description: err.response.data.message,
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
    }
  },

  components: {
    InputProposal,
    InputConstant
  }
}
</script>

<template>
  <div>
    <v-card class="beez-card" v-if="botTemplate">
      <v-toolbar dense card class="elevation-2">
        <v-toolbar-title class="body-2 beez-bold "
          >{{ botTemplate.name }}
        </v-toolbar-title>
        <v-spacer />
        <v-tooltip bottom v-if="isCard">
          <v-btn icon flat slot="activator" @click="gotoList">
            <v-icon>list</v-icon>
          </v-btn>
          <span>Goto Bot Template List</span>
        </v-tooltip>
        <v-dialog max-width="60%" v-model="botTemplateBinariesUpdation">
          <v-tooltip bottom slot="activator">
            <v-btn
              icon
              @click.stop="botTemplateBinariesUpdation = true"
              slot="activator"
            >
              <v-icon>system_update_alt</v-icon>
            </v-btn>
            <span class="ml-2"> Update Bot </span>
          </v-tooltip>
          <template>
            <v-card>
              <v-toolbar dense card class="elevation-2">
                <v-toolbar-title class="body-2 beez-bold ">
                  Update Bot
                </v-toolbar-title>
                <v-layout justify-end align-center>
                  <v-btn
                    flat
                    icon
                    @click.stop="botTemplateBinariesUpdation = false"
                  >
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-layout>
              </v-toolbar>
              <v-progress-linear
                indeterminate
                color="accent"
                class="ma-0"
                height="5"
                :active="botTemplateBinariesUpdating"
              />
              <v-layout row wrap class="beez-padding">
                <v-flex xs12>
                  <v-text-field
                    color="secondary"
                    v-model="botTemplateBinariesClassName"
                    outline
                    clearable
                    label="Class name of the Bot"
                    type="text"
                  >
                    <template v-slot:prepend>
                      <v-tooltip bottom>
                        <template>
                          <v-icon slot="activator ">help_outline</v-icon>
                        </template>
                        The Hive loads the Bot based on the Class name
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="beez-padding">
                <v-flex xs12>
                  <div class="v-input">
                    <v-btn
                      flat
                      class="text-capitalize"
                      color="secondary"
                      @click="$refs.updateBinInput.click()"
                    >
                      <v-icon>
                        cloud_upload
                      </v-icon>
                      <span>&nbsp; Add the Bot binary file (.dll or .jar)</span>
                    </v-btn>
                    <input
                      @change="uploadUpdateBinFile"
                      v-show="false"
                      ref="updateBinInput"
                      type="file"
                      :accept="acceptFormats"
                    />
                  </div>
                </v-flex>
                <v-flex xs12 md6 lg3 v-if="binFile">
                  <v-card
                    :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
                    style="border-radius: 5px"
                  >
                    <v-toolbar flat>
                      <div>Bot binary</div>
                      <v-spacer></v-spacer>
                      <v-icon>attachment</v-icon>
                    </v-toolbar>
                    <v-card-title primary-title>
                      <div>
                        <div class="subheading">
                          File name: {{ binFile.name }}
                        </div>
                      </div>
                    </v-card-title>
                    <v-card-text>
                      <div>
                        <div class="text-xs-left body-1">
                          File size (in Bytes): {{ binFile.size }}
                        </div>
                        <div class="text-xs-left caption">
                          Last modified date: {{ binFile.lastModifiedDate }}
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="beez-padding">
                <v-flex xs12>
                  <div class="v-input">
                    <v-btn
                      flat
                      class="text-capitalize"
                      color="secondary"
                      @click="$refs.updateLibsInput.click()"
                    >
                      <v-icon>
                        cloud_upload
                      </v-icon>
                      <span>&nbsp; Add Dependencies (Optional)</span>
                    </v-btn>

                    <input
                      v-show="false"
                      @change="uploadUpdateLibFile"
                      ref="updateLibsInput"
                      type="file"
                      multiple
                    />
                  </div>
                </v-flex>
                <v-flex
                  xs12
                  v-if="libFiles && libFiles.length > 0"
                  class="pa-3"
                >
                  <v-layout class="row wrap">
                    <v-flex
                      :key="key + 'item'"
                      xs12
                      md6
                      lg3
                      class="pa-2"
                      v-for="(item, key) in libFiles"
                    >
                      <v-card
                        :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
                        style="border-radius: 5px"
                      >
                        <v-toolbar flat>
                          <div>Bot dependent - {{ key + 1 }}</div>
                          <v-spacer></v-spacer>
                          <v-icon>attachment</v-icon>
                        </v-toolbar>
                        <v-card-title primary-title>
                          <div>
                            <div class="subheading">
                              File name: {{ item.name }}
                            </div>
                          </div>
                        </v-card-title>
                        <v-card-text>
                          <div>
                            <div class="text-xs-left body-1">
                              File size (in Bytes): {{ item.size }}
                            </div>
                            <div class="text-xs-left caption">
                              Last modified date: {{ item.lastModifiedDate }}
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-card-actions>
                <v-layout justify-center>
                  <v-btn
                    class="text-capitalize"
                    :class="!$vuetify.dark ? 'secondary' : ''"
                    :color="$vuetify.dark ? 'secondary' : ''"
                    :outline="$vuetify.dark"
                    :disabled="!(binFile && botTemplateBinariesClassName)"
                    @click="updateBotBinaries"
                    :loading="botTemplateBinariesUpdating"
                    >Update
                  </v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
        <v-tooltip bottom>
          <v-btn
            icon
            @click="incubateBot(botTemplate)"
            slot="activator"
            :loading="botIncubateLoader"
            v-if="can('BOT_TEMPLATE_INCUBATION')"
          >
            <v-icon>offline_bolt</v-icon>
          </v-btn>
          <span class="ml-2"> Incubate </span>
        </v-tooltip>
      </v-toolbar>
      <v-progress-linear
        indeterminate
        color="accent"
        class="ma-0"
        height="5"
        :active="botTemplateUpdating"
      />
      <div class="pa-3">
        <v-layout align-center justify-space-between row fill-height wrap>
          <v-flex grow>
            <v-text-field
              :outline="$vuetify.dark"
              color="secondary"
              label="Name"
              v-model="name"
              :readonly="!editName"
            >
              <template slot="append">
                <template v-if="editName">
                  <v-icon @click="resetName">clear</v-icon>
                  <v-icon @click="setName">save</v-icon>
                </template>
                <template v-else>
                  <v-icon
                    v-if="can('BOT_TEMPLATE_NAME_EDIT')"
                    @click="editName = true"
                    >edit
                  </v-icon>
                </template>
              </template>
            </v-text-field>
          </v-flex>
          <v-flex grow>
            <v-text-field
              :outline="$vuetify.dark"
              class="pl-1"
              color="secondary"
              label="Agent(s) Bot Identifier"
              v-model="hiveBotId"
              :readonly="!editHiveBotId"
            >
              <template slot="append">
                <template v-if="editHiveBotId">
                  <v-icon @click="resetHiveBotId">clear</v-icon>
                  <v-icon @click="setHiveBotId">save</v-icon>
                </template>
                <template v-else>
                  <v-icon
                    v-if="can('BOT_TEMPLATE_AGENT_EDIT')"
                    @click="editHiveBotId = true"
                    >edit
                  </v-icon>
                </template>
              </template>
            </v-text-field>
          </v-flex>
        </v-layout>

        <v-textarea
          label="Description"
          v-model="description"
          :readonly="!editDescription"
          :rows="1"
          :outline="$vuetify.dark"
          color="secondary"
          auto-grow
        >
          <template slot="append">
            <template v-if="editDescription">
              <v-icon @click="resetDescription">clear</v-icon>
              <v-icon @click="setDescription">save</v-icon>
            </template>
            <template v-else>
              <v-icon
                v-if="can('BOT_TEMPLATE_DES_EDIT')"
                @click="editDescription = true"
                >edit
              </v-icon>
            </template>
          </template>
        </v-textarea>

        <v-layout align-center justify-space-between row fill-height wrap>
          <v-flex grow>
            <v-select
              :outline="$vuetify.dark"
              color="secondary"
              :items="hiveTypes"
              item-text="friendlyName"
              item-value="key"
              v-model="hiveTypeSelected"
              label="Agent Type"
              :readonly="!editHive"
              disabled
            >
            </v-select>
          </v-flex>
          <v-flex grow>
            <v-text-field
              class="pl-1"
              :outline="$vuetify.dark"
              color="secondary"
              label="Agent"
              v-model="hiveSelected.name"
              readonly
              v-if="hiveSelected && filteredHivesForHiveType.length === 0 && !editHive"
              disabled
            ></v-text-field>
            <v-select
              v-else
              class="pl-1"
              :outline="$vuetify.dark"
              color="secondary"
              :items="filteredHivesForHiveType"
              item-text="name"
              item-value="hexId"
              v-model="hiveSelected"
              label="Agent"
              return-object
              :readonly="!editHive"
              disabled
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-text-field
          :outline="$vuetify.dark"
          color="secondary"
          label="Effort savings in Person-Minutes"
          v-model="effortSaved"
          :readonly="!editEffortSaved"
          mask="######"
        >
          <template slot="append">
            <template v-if="editEffortSaved">
              <v-icon @click="resetEffortSaved">clear</v-icon>
              <v-icon @click="setEffortSaved">save</v-icon>
            </template>
            <v-icon v-else @click="editEffortSaved = true">edit</v-icon>
          </template>
        </v-text-field>

        <v-text-field
          :outline="$vuetify.dark"
          color="secondary"
          label="Class Name"
          v-model="className"
          :loading="hiveBotDataUpdating"
          readonly
        >
        </v-text-field>

        <v-text-field
          prepend-icon="fingerprint"
          :outline="$vuetify.dark"
          color="secondary"
          label="Unique Version Identifier"
          v-model="hash"
          :loading="hiveBotDataUpdating"
          readonly
        >
        </v-text-field>

        <div
          class="py-4"
          v-if="
            Array.isArray(bots[botTemplate.hexId]) &&
              bots[botTemplate.hexId].length &&
              can('BOT_TEMPLATE_BOTS')
          "
        >
          <v-card class="fill-height">
            <v-layout column fill-height>
              <v-flex shrink>
                <v-toolbar dense card class="elevation-2">
                  <v-toolbar-title class="body-2 beez-bold "
                    >Bots
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-progress-linear
                  indeterminate
                  class="ma-0"
                  color="accent"
                  height="5"
                  :active="botUpating"
                />
              </v-flex>
              <v-flex grow>
                <transition name="bounce" mode="out-in">
                  <v-list
                    two-line
                    key="view-workflow-list"
                    style="max-height: 760px"
                    class="scroll-y"
                  >
                    <template v-for="(bot, i) in bots[botTemplate.hexId]">
                      <v-hover>
                        <v-list-tile-content slot-scope="{ hover }">
                          <v-container fulid>
                            <v-layout row>
                              <v-flex shrink pl-3>
                                <v-avatar size="40">
                                  <img src="/images/Workflow.svg" alt="link" />
                                </v-avatar>
                              </v-flex>
                              <v-flex grow pl-3>
                                <v-list-tile-title
                                  >{{ bot.name }}
                                </v-list-tile-title>
                                <v-list-tile-sub-title
                                  >{{ bot.description }}
                                </v-list-tile-sub-title>
                              </v-flex>
                              <v-flex shrink>
                                <v-tooltip bottom>
                                  <v-btn
                                    v-if="hover"
                                    slot="activator"
                                    icon
                                    flat
                                    small
                                    :to="{
                                      name: 'bot-detail',
                                      params: { hexId: bot.hexId }
                                    }"
                                  >
                                    <v-icon>link</v-icon>
                                  </v-btn>
                                  <span>Quick Link</span>
                                </v-tooltip>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-list-tile-content>
                      </v-hover>
                    </template>
                  </v-list>
                </transition>
              </v-flex>
            </v-layout>
          </v-card>
        </div>
        <div class="py-4" v-if="can('BOT_TEMPLATE_PROPOSAL')">
          <input-proposal
            :key="botTemplate.hexId + 'input-render'"
            :input-proposal="botTemplate.proposals"
            @save="setProposals"
          />
        </div>
        <div class="pb-4" v-if="can('BOT_TEMPLATE_CONSTANTS')">
          <input-constant
            :key="botTemplate.hexId + 'constant-render'"
            :input-constant="botTemplate.constants"
            @save="setConstants"
          />
        </div>
      </div>
    </v-card>
  </div>
</template>

<style scoped></style>
